﻿import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { RequirementProject } from '../../models/Testing/requirement-project';
import { RequirementCategory } from '../../models/Testing/requirement-category';
import { RequirementSpecification } from '../../models/Testing/requirement-specification';
import { Document } from '../../models/document';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import RequirementSpecificationsEditor from './RequirementSpecificationsEditor';
import { CrudFunctions } from '../../utilities/crud-functions';
import DocumentLoader from '../DocumentLoader';
import { DocumentationConstants } from '../../store/documentation-constants';
import DmaFooter from '../DmaFooter';
import { ModalMetadata } from '../../models/modal-metadata';
import { EditType, ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    HeaderFilter,
    Pager,
    Paging,
    Editing,
    Popup,
    Form,
    Lookup,
    Button as ColumnButton,
    SearchPanel,
    Toolbar,
    Item as ToolBarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import TreeView from 'devextreme-react/tree-view';
import { Item } from 'devextreme-react/form';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export default function SoftwareRequirementsForm() {
    const [projects, setProjects] =
        useState<RequirementProject[]>();

    const [selectedProject, setSelectedProject] =
        useState<RequirementProject>();

    const [categories, setCategories] =
        useState<RequirementCategory[]>();

    const [mainCategories, setMainCategories] =
        useState<RequirementCategory[]>();

    const [subCategories, setSubcategories] =
        useState<RequirementCategory[]>();

    const [selectedCategory, setSelectedCategory] =
        useState<RequirementCategory>();

    const [selectedSubcategory, setSelectedSubcategory] =
        useState<RequirementCategory>();

    const [requirementSpecificationsEditorVisible, setRequirementSpecificationsEditorVisible] =
        useState<boolean>();

    const [editedCategory, setEditedCategory] =
        useState<RequirementCategory>();

    const [editCategoryDialogVisible, setEditCategoryDialogVisible] =
        useState<boolean>();

    const [editCategoryDialogTitle, setEditCategoryDialogTitle] =
        useState<string>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getProjectData();
    }, [selectedProject]);

    useEffect(() => {
        getSubcategories();
    }, [selectedCategory]);

    ++key;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Software Requirements</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back" className="title-bar-button"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>
                    {/*
                    <div>
                        <NavLink to={`/documentation/${DocumentationConstants.ColumnsForm}`}
                            className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                            <Button className="title-bar-button pw-orange"
                                text="" icon="help" type="normal"
                                hint="help and documentation" />
                        </NavLink>
                    </div>
                    */}
                </div>
            </div>

            <div>
                <div className="two-column-grid">

                    <div className="pw-margin-bottom-05">
                        <DataGrid
                            height="20rem" width="100%"
                            keyExpr="requirementProjectId"
                            dataSource={projects ? projects : []}
                            onSelectionChanged={onProjectsSelectionChanged}
                            onRowValidating={onProjectsRowValidating}
                            onRowRemoving={onProjectsRowRemoving}
                            allowColumnResizing={true}
                            onInitNewRow={onInitNewGcColumnRow}
                            wordWrapEnabled={true}
                            columnResizingMode='widget'
                            rowAlternationEnabled={true}
                            showRowLines={true}
                            showBorders={true} >

                            <LoadPanel enabled={true} />
                            <Selection mode={'single'} />
                            <Paging enabled={false} />

                            <Column type="buttons" width="9rem">
                                <ColumnButton name="edit" />
                                <ColumnButton name="delete" />
                                <ColumnButton hint="audit information" icon="clock"
                                    onClick={showProjectsAuditDialog} />
                                <ColumnButton hint="information" icon="info"
                                    onClick={onProjectInformationButtonClicked} />
                            </Column>

                            <Column dataField='name' width='10rem' dataType="string" />
                            <Column dataField='phase' width='7rem' dataType="number" />
                            <Column dataField='description' dataType="string" />

                            <Toolbar>
                                <ToolBarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Projects</div>
                                    </div>
                                </ToolBarItem>
                                <ToolBarItem location="after" name="searchPanel" />
                                <ToolBarItem location="after" name="addRowButton" />
                            </Toolbar>

                            <Editing
                                mode="popup"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={true} />
                        </DataGrid>
                    </div>

                    <div className="pw-margin-bottom-05">
                        <div className="lq-header pw-margin-bottom-05 aurum-blue-bg">
                            <div className="lq-header-title">Categories</div>
                            <div className="title-bar-spacer" />
                            <div>
                                <Button className="title-bar-button"
                                    text="Specifications" icon="bulletlist" type="normal"
                                    hint="go to specifications" disabled={!selectedCategory}
                                    onClick={onOpenSpecificationsDialog} />
                            </div>
                            <div>
                                <Button className="title-bar-button"
                                    text="" icon="plus" type="normal"
                                    hint="add item"
                                    onClick={onAddCategoryClick} />
                            </div>
                            <div>
                                <Button className="title-bar-button"
                                    text="" icon="increaseindent" type="normal"
                                    hint="add subcategory" disabled={!selectedCategory}
                                    onClick={onAddSubcategoryClick} />
                            </div>
                            <div>
                                <Button className="title-bar-button"
                                    text="" icon="edit" type="normal"
                                    hint="edit item" disabled={!selectedCategory && !selectedSubcategory}
                                    onClick={onEditItemClick} />
                            </div>
                            <div>
                                <Button className="title-bar-button"
                                    text="" icon="trash" type="normal"
                                    hint="remove item" disabled={!selectedCategory && !selectedSubcategory}
                                    onClick={onDeleteItemClick} />
                            </div>
                        </div>

                        <div style={{ border: "1px solid #aaa" }}>
                            <TreeView id="locationTree" height="16rem"
                                dataStructure="plain"
                                items={categories ? categories : []}
                                keyExpr="requirementCategoryId" displayExpr="name"
                                parentIdExpr="parentId"
                                onItemClick={onCategoriesNodeClick} />
                        </div>

                    </div>
                </div>

                <DmaFooter />
            </div>

            {editCategoryDialogVisible &&
                <DialogPopup visible={editCategoryDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title={editCategoryDialogTitle}
                    width='25rem'
                    height='16rem'
                    dragEnabled={false}
                    resizeEnabled={false}>

                    <div key={`C${key}`}>
                        <div className="pw-form-unit pw-margin-bottom-05">
                            <div className="pw-form-unit-label">Name</div>
                            <TextBox id="editedCategoryNameTextBox" placeholder="na"
                                onValueChanged={onEditedCategoryNameChanged}
                                value={editedCategory && editedCategory.name ? editedCategory.name : undefined} />
                        </div>
                        <div className="pw-form-unit pw-margin-bottom-05">
                            <div className="pw-form-unit-label">Description</div>
                            <TextBox id="editedCategoryDescriptionTextBox"
                                placeholder="na"
                                onValueChanged={onEditedCategoryDescriptionChanged}
                                value={editedCategory && editedCategory.description ? editedCategory.description : undefined} />
                        </div>

                        <div className="pw-centered-buttons-container">
                            <Button id="saveButton" text="Save" icon="save" type="success"
                                className="pw-button"
                                hint="save changes"
                                height='1.8rem'
                                onClick={onSaveCategoryClick} />

                            <Button id="cancelButton" text="Close" icon="close" type="normal"
                                className="pw-button"
                                hint="close dialog"
                                height='1.8rem'
                                onClick={hideEditCategoryDialog} />
                        </div>
                    </div>
                </DialogPopup>
            }

            {requirementSpecificationsEditorVisible &&
                <DialogPopup visible={requirementSpecificationsEditorVisible}
                    onHiding={hideRequirementSpecificationsEditor}
                    title="Requirement Specifications"
                    fullScreen={true}>
                    <RequirementSpecificationsEditor key={`RS${key}`}
                        projectId={selectedProject && selectedProject.requirementProjectId}
                        category={selectedCategory} isReadOnly={false} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width='25rem'
                    height='21rem'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onOpenSpecificationsDialog() {
        showRequirementSpecificationsEditor();
    }

    function onEditedCategoryNameChanged(e: any) {
        setEditedCategory({ ...editedCategory, name: e.value });
    }


    function onEditedCategoryDescriptionChanged(e: any) {
        setEditedCategory({ ...editedCategory, description: e.value });
    }


    function onCategoriesNodeClick(e: any) {
        console.log("onCategoriesNodeClick");
        console.log(e);

        if (e.itemData) {
            if (e.itemData.parentId) {
                setSelectedSubcategory(e.itemData);
                setSelectedCategory(null);

            }
            else {
                setSelectedSubcategory(null);
                setSelectedCategory(e.itemData);
            }
        }
    }

    function onAddCategoryClick() {
        if (selectedProject) {
            let newCategory: RequirementCategory = {
                requirementProjectId: selectedProject.requirementProjectId,
                editType: EditType.Insert
            };

            setEditCategoryDialogTitle("Add Category");
            setEditedCategory(newCategory);

            showEditCategoryDialog();
        }
    }

    function onAddSubcategoryClick() {
        if (selectedCategory && selectedProject) {
            let newSubcategory: RequirementCategory = {
                requirementProjectId: selectedProject.requirementProjectId,
                parentId: selectedCategory.requirementCategoryId,
                editType: EditType.Insert
            }

            setEditCategoryDialogTitle("Add Subcategory");
            setEditedCategory(newSubcategory);

            showEditCategoryDialog();
        }
    }

    function onEditItemClick() {
        if (selectedCategory) {
            let currentCategory = { ...selectedCategory };
            currentCategory.editType = EditType.Update;

            setEditedCategory(currentCategory);
            setEditCategoryDialogTitle("Edit Category");

            showEditCategoryDialog();
        }
        else if (selectedSubcategory) {
            let currentCategory = { ...selectedSubcategory };
            currentCategory.editType = EditType.Update;

            setEditedCategory(currentCategory);
            setEditCategoryDialogTitle("Edit Subcategory");

            showEditCategoryDialog();
        }
    }

    async function onSaveCategoryClick() {
        //console.log("onSaveCategoryClick");
        //console.log(editedCategory);

        if (editedCategory) {
            if (editedCategory.editType === EditType.Update) {
                await updateCategory(editedCategory)
                    .then(() => {
                        
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Category");
                    });
            }
            else if (editedCategory.editType === EditType.Insert) {
                await insertCategory(editedCategory)
                    .then(() => {

                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Category");
                    });
            }

            if (selectedProject)
                getCategoriesByProjectId(selectedProject.requirementProjectId);
            else
                getProjects();

            hideEditCategoryDialog();
        }
    }

    function onDeleteItemClick() {
        console.log("onDeleteItemClick");
        console.log(selectedCategory);
    }

    function onProjectsSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedProject(e.selectedRowsData[0]);
    }

    function onCategoriesSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedCategory(e.selectedRowsData[0]);
    }



    async function onInitNewGcColumnRow(e: any) {

    }

    // validating

    async function onProjectsRowValidating(e: any) {
        if (e.oldData) {
            let project = e.oldData as RequirementProject;

            if (project) {
                let updatedProject = { ...project, ...e.newData };

                updateProject(updatedProject)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Project");
                    });
            }
        }
        else {
            if (e.newData) {
                let project = e.newData as RequirementProject;

                if (project) {
                    await insertProject(project)
                        .then(() => {
                            getProjects();
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Project");
                        });
                }
            }
        }
    }

    async function onCategoriesRowValidating(e: any) {
        if (e.oldData) {
            let category = e.oldData as RequirementCategory;

            if (category) {
                let updatedCategory = { ...category, ...e.newData };

                updateCategory(updatedCategory)
                    .then(() => {
                        // if (selectedGcColumnHeader && selectedGcColumnHeader.columnHeaderId)
                        //   getGcColumnEntries(selectedGcColumnHeader.columnHeaderId);
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Category");
                    });
            }
        }
        else {
            if (e.newData) {
                let category = e.newData as RequirementCategory;

                if (category && selectedProject) {
                    category.requirementProjectId = selectedProject.requirementProjectId;

                    await insertCategory(category)
                        .then(() => {
                            //if (selectedGcColumnHeader && selectedGcColumnHeader.columnHeaderId)
                            //  getGcColumnEntries(selectedGcColumnHeader.columnHeaderId);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Updating Category");
                        });
                }
            }
        }
    }


    // delete

    function onProjectsRowRemoving(e: any) {

    }

    function onCategoriesRowRemoving(e: any) {

    }

    function onSpecificationsRowRemoving(e: any) {

    }

    function onProjectInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.requirementProjectId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            showItemBasicInformationDialog();
        }
    }

    function onCategoryInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.requirementCategoryId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            showItemBasicInformationDialog();
        }
    }

    // get functions

    async function getProjects() {
        await CrudFunctions.getData("testing/requirementprojects")
            .then(data => {
                console.log(data);
                setProjects(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Projects");
            });
    }

    async function getCategoriesByProjectId(projectId: string) {
        await CrudFunctions.getData(`testing/categories/${projectId}`)
            .then(data => {
                let cats = data as RequirementCategory[];

                if (cats) {
                    setMainCategories(cats.filter(c => !c.parentId));
                    setSubcategories(cats.filter(c => c.parentId));
                }

                setCategories(cats);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Categories");
            });
    }

  
    //POST functions

    async function insertProject(project: RequirementProject) {
        return CrudFunctions.postData("testing/requirementproject", project);
    }

    async function insertCategory(category: RequirementCategory) {
        return CrudFunctions.postData("testing/requirementcategory", category);
    }

    //PUT functions

    async function updateProject(project: RequirementProject) {
        return CrudFunctions.putData("testing/requirementproject", project);
    }

    async function updateCategory(category: RequirementCategory) {
        return CrudFunctions.putData("testing/requirementcategory", category);
    }

    // DELETE functions


    async function getAllData() {
        await Promise.all([
            getProjects()
        ])
    }

    async function getProjectData() {
        if (selectedProject) {
            await Promise.all([
                getCategoriesByProjectId(selectedProject.requirementProjectId)
            ])
        }
    }

    function getSubcategories() {
        if (selectedCategory) {
            let selectedCategorySubitems = subCategories.filter(c => c.parentId === selectedCategory.requirementCategoryId);

            setSubcategories(selectedCategorySubitems);
        }
    }

    //show/hide

    function showEditCategoryDialog() {
        setEditCategoryDialogVisible(true);
    }

    function hideEditCategoryDialog() {
        setEditCategoryDialogVisible(false);
    }

    function showRequirementSpecificationsEditor() {
        setRequirementSpecificationsEditorVisible(true);
    }

    function hideRequirementSpecificationsEditor() {
        setRequirementSpecificationsEditorVisible(false);
    }

    function showItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(true);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showProjectsAuditDialog(e: any) {
        if (e.row && e.row.data) {
            //todo
        }
    }

    function showCategoriesAuditDialog(e: any) {
        if (e.row && e.row.data) {
            //todo
        }
    }

    //render

    function datagridCellRender(e: any) {
        if (e.data) {
            const css = e.data.dateRetired ? "validation-fail" : "validation-pass";
            return (<div className={css}>{e.displayValue}</div>);
        }
        else
            return (<div>{e.displayValue}</div>);
    }

    //navigation

    function goBack() {
        history.back();
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
